import { ExternalLink, Phone } from "lucide-react";

export const hotels = [
  {
    name: "Glenlo Abbey Hotel",
    distance: "On site",
    note: "Stay where the reception is — five-star estate rooms set across 138 acres.",
    url: "https://www.glenloabbeyhotel.ie/",
  },
  {
    name: "Abbey View B&B",
    distance: "1 min drive · Practically next door",
    note: "Family-run B&B almost directly across from Glenlo Abbey — modern rooms and a lovely Irish breakfast.",
    url: "https://www.abbeyviewgalway.com/",
  },
  {
    name: "Kilbree House B&B",
    distance: "6 min drive · Circular Road",
    note: "Family-run four-star B&B with spacious en-suite rooms, free parking, and a generous breakfast.",
    url: "https://kilbreehouse.ie/",
  },
  {
    name: "The Twelve Hotel, Barna",
    distance: "12 min drive · Coastal village",
    note: "Stylish boutique hotel in Barna village — a popular, friendlier-priced alternative to Glenlo.",
    url: "https://www.thetwelvehotel.ie/",
  },
  {
    name: "The Connemara Coast Hotel, Furbo",
    distance: "18 min drive · Sea views",
    note: "Four-star seaside hotel with views over Galway Bay — relaxed and great value.",
    url: "https://www.connemaracoasthotel.ie/",
  },
  {
    name: "Salthill Hotel",
    distance: "12 min drive · Galway Bay",
    note: "Right on the Salthill promenade — comfortable, mid-priced rooms with sea views.",
    url: "https://www.salthillhotel.com/",
  },
  {
    name: "Travelodge Galway",
    distance: "12 min drive · Budget pick",
    note: "Simple, well-priced rooms close to Eyre Square and the train station.",
    url: "https://www.travelodge.ie/hotels/252/Galway-City-hotel",
  },
  {
    name: "Winacre Lodge B&B",
    distance: "3 min drive · Bushy Park",
    note: "Modern B&B with River Corrib views, free parking and a hearty breakfast — practically on Glenlo's doorstep.",
    url: "tel:+353091523459",
    phoneLabel: "Call 091 523 459",
  },
  {
    name: "The Hardiman",
    distance: "10 min drive · Eyre Square",
    note: "Historic landmark hotel right in the heart of Galway, beside the train station.",
    url: "https://www.thehardiman.ie/",
  },
  {
    name: "The House Hotel",
    distance: "12 min drive · Latin Quarter",
    note: "Boutique design hotel tucked beside the Spanish Arch in Galway's Latin Quarter.",
    url: "https://www.thehousehotel.ie/",
  },
];

export function HotelCard({ h }) {
  const isPhone = (h.url || "").startsWith("tel:");
  return (
    <a
      href={h.url}
      target={isPhone ? undefined : "_blank"}
      rel={isPhone ? undefined : "noreferrer noopener"}
      data-testid={`hotel-card-${h.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group bg-[#FAF9F6] border border-[#A3C1DA]/40 p-6 md:p-7 hover:-translate-y-1 hover:border-[#6A1E2D]/40 transition-all duration-300 flex flex-col"
    >
      <p className="text-[10px] tracking-luxe uppercase text-[#6A1E2D] mb-3">
        {h.distance}
      </p>
      <h4 className="font-display text-2xl text-[#1A1818] mb-3 leading-tight">
        {h.name}
      </h4>
      <p className="text-sm text-[#4A4747] leading-relaxed mb-5 flex-1">
        {h.note}
      </p>
      <span className="inline-flex items-center gap-2 text-xs tracking-luxe uppercase text-[#6A1E2D] group-hover:gap-3 transition-all">
        {isPhone ? (
          <>
            <Phone className="w-3 h-3" strokeWidth={1.6} />
            {h.phoneLabel || "Call to enquire"}
          </>
        ) : (
          <>
            Visit website
            <ExternalLink className="w-3 h-3" strokeWidth={1.6} />
          </>
        )}
      </span>
    </a>
  );
}
